// Angular
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
// Lodash & RxJs
import { get, split, trim } from 'lodash';
import { Observable, of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
// Service
import { CommonService } from '@core/utils';
import { PartSearchService } from '../../partsearch-shared-module/service';
// Constants
import { ORIGIN_SAVED_PARTS, SAVE_PART_LS_KEY } from '@constants';
// Transloco
import { TranslocoService } from '@jsverse/transloco';

/** Get Parts Detail Resolver Funtion */
export const fetchPartsDetailResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    // Dependency
    const cs = inject(CommonService);
    const partSearchService = inject(PartSearchService);
    const router = inject(Router);
    const translocoService = inject(TranslocoService);

    const query_post_id = get(route, 'queryParams.post_id');
    const parts = cs.getFromLocalStorage(SAVE_PART_LS_KEY);
    if (parts && parts.length != 0 && parts[0].id) return parts.map((i: any) => i.id);

    const post_id = parts ? parts : [];

    let resolvedPostId: Array<number> = [];
    if (query_post_id && trim(query_post_id) !== '') {
        resolvedPostId = split(query_post_id, ',').map((i) => Number(i));
    } else if (post_id) {
        resolvedPostId = post_id;
    }
    if (resolvedPostId.length === 0) return of([]);
    
    return partSearchService
        .getSavedPartsProductList(resolvedPostId, ORIGIN_SAVED_PARTS)
        .pipe(
            take(1),
            tap((response: any) => {
                const lang = translocoService.getActiveLang();

                // If the response indicates access is forbidden, redirect to the 403 error page
                if (response?.status === 403) {
                    router.navigate(['/', lang, 'error', '403'], { replaceUrl: true });
                    throw new Error('Redirecting to error 403 page.');
                }

                // If the response indicates a captcha is required, redirect to the captcha page
                if (response?.status === 422) {
                    const returnUrl = state.url !== '/' ? state.url : undefined;
                    router.navigate(['/', lang, 'captcha'], {
                        replaceUrl: true,
                        queryParams: {
                            returnUrl: returnUrl
                        }
                    });
                    throw new Error('Redirecting to captcha page.');
                }
            }),
            catchError((error) => {
                return of([]);
            })
        );
};
